import noFoodImage from '../assets/no-food.png';

export const userName = 'User';
export const passwordName = 'Password';
export const bearer = 'Bearer';
export const apiUrl = '/api/';
export const allOption = 'All';
export const orderNowForPickupTomorrow = 'Order now for pickup tomorrow';
export const orderNowForPickupWhenOpen = 'Order now for pickup after opening';
export const onlineOrderingUnavailable = 'Ordering online is currently not available';
export const proceedToPayment = 'Proceed to payment';
export const placeOrder = 'Place order';
// Orders with a total above this amount (inc GST) must be paid online by card
// up front — "pay at pickup" and loyalty-point settlement are not permitted.
// Keep in sync with PaymentTypes.OnlinePaymentRequiredThreshold on the API.
export const onlinePaymentRequiredThreshold = 50;

export const maxFileSize = 10 * 1024 * 1024; // 10MB
export const allowedImageFileTypes = ['png', 'jpg', 'jpeg', 'webp'];
export const defaultComponentImage = noFoodImage;
export const limitPerPage = {
    default: 20,
}